"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ListData = exports.OutFunction = exports.InitFunction = exports.useWeb = void 0;
// ----------- import Packs
var react_1 = __importDefault(require("react"));
// ----------- import Internals
var ListData_1 = require("./src/ListData");
// ----------- export Functions to Library
var useWeb_1 = require("./src/useWeb");
__createBinding(exports, useWeb_1, "useWeb");
var InitFunction_1 = require("./src/InitFunction");
__createBinding(exports, InitFunction_1, "InitFunction");
var OutFunction_1 = require("./src/OutFunction");
__createBinding(exports, OutFunction_1, "OutFunction");
/**
 * Maps Ids and pass them to children components

  'Example to Copy':

  const ProdsList = () => {
    // ---------- set Data
    const idsArr = ['xxx0', 'xxx1'];
    const infoItems = { xxx0: { name: 'Item 1' }, xxx1: { name: 'Item 2' } };

    // ---------- set Components
    const NoItemView = () => <Text>{'No Item'}</Text>;
    type Tprops = { infoItem: { name: string } };
    const ItemComp = ({ infoItem }: Tprops) => <Text>{infoItem.name}</Text>;

    // ---------- set CallBack Function List
    const listCBFn = (itemId: keyof typeof infoItems, noItem: boolean) => {
      const noItemComp = () => <NoItemView />;
      const currItem = infoItems[itemId];
      const itemComp = () => <ItemComp key={itemId} infoItem={currItem} />;
      return noItem ? noItemComp() : itemComp();
    };
    // ---------- set return
    return <ListData idsArr={idsArr} listCBFn={listCBFn} />;
  }

  * @param props.idsArr - Get Central Data to use
  * @callback props.listCBFn - CallBack Function to iterate over each item of the 'idsArr'
  * @param itemId - Receives each id in the 'idsArr'
  * @param noItem - Receives true information when the list size is 0.
  * @param props.type - Sets list type as 'vertical' (default) or 'horizontal'
  * @param props.cols - Sets the optional columns list number
 */
var ListData = function (props) { return react_1["default"].createElement(ListData_1.ListData, __assign({}, props)); };
exports.ListData = ListData;
